import React, { useState, useCallback, useEffect } from "react";
import CardFeaturedPostsWrapper from "./cardFeaturedPosts";
var CardFeaturedPosts = function (_a) {
    var posts = _a.posts, _b = _a.delay, delay = _b === void 0 ? 7000 : _b;
    var _c = useState(0), activeIndex = _c[0], setActiveIndex = _c[1];
    var featuredPost = posts.slice(0, 5);
    var nextActive = useCallback(function () {
        if (activeIndex < featuredPost.length - 1) {
            setActiveIndex(function (prev) { return prev + 1; });
        }
        else {
            setActiveIndex(0);
        }
    }, [activeIndex]);
    var prevActive = useCallback(function () {
        if (activeIndex > 0) {
            setActiveIndex(function (prev) { return prev - 1; });
        }
        else {
            setActiveIndex(featuredPost.length - 1);
        }
    }, [activeIndex]);
    useEffect(function () {
        var timeout = setTimeout(function () {
            nextActive();
        }, delay);
        return function () {
            clearTimeout(timeout);
        };
    }, [delay, activeIndex]);
    return (React.createElement(CardFeaturedPostsWrapper, { posts: featuredPost, onNextClick: nextActive, onPrevClick: prevActive, activeIndex: activeIndex, delay: delay, setActiveIndex: setActiveIndex }));
};
export default CardFeaturedPosts;
